//# sourceMappingURL=sketch.mjs.map
/// <reference types="./sketch.d.mts" />
import { Ok, CustomType as $CustomType } from "./gleam.mjs";
import { uniqueId as unique_id } from "./sketch.ffi.mjs";
import * as $css from "./sketch/css.mjs";
import * as $error from "./sketch/error.mjs";
import * as $cache from "./sketch/internals/cache/cache.mjs";

class StyleSheet extends $CustomType {
  constructor(cache, id, is_persistent) {
    super();
    this.cache = cache;
    this.id = id;
    this.is_persistent = is_persistent;
  }
}

export class Ephemeral extends $CustomType {}
export const Strategy$Ephemeral = () => new Ephemeral();
export const Strategy$isEphemeral = (value) => value instanceof Ephemeral;

export class Persistent extends $CustomType {}
export const Strategy$Persistent = () => new Persistent();
export const Strategy$isPersistent = (value) => value instanceof Persistent;

/**
 * Render the content in the stylesheet in proper CSS stylesheet.
 */
export function render(cache) {
  return $cache.render_sheet(cache.cache);
}

/**
 * Converts a `Class` to its class name, to use it anywhere in your application.
 * It always returns the StyleSheet, because the class can have been pushed
 * in the StyleSheet itself.
 */
export function class_name(class$, stylesheet) {
  let $ = $cache.class_name(class$, stylesheet.cache);
  let cache = $[0];
  let class_name$1 = $[1];
  return [
    new StyleSheet(cache, stylesheet.id, stylesheet.is_persistent),
    class_name$1,
  ];
}

/**
 * Pushes an `@rule` in the StyleSheet, to get it bundled in the outputted CSS.
 * It returns the StyleSheet with the rule added.
 */
export function at_rule(rule, stylesheet) {
  let cache = $cache.at_rule(rule, stylesheet.cache);
  return new StyleSheet(cache, stylesheet.id, stylesheet.is_persistent);
}

/**
 * Pushes a global class in the StyleSheet, to get it bundled in the outputted CSS.
 * It returns the StyleSheet with the rule added.
 */
export function global(stylesheet, global) {
  let $ = $cache.class_name(global.class, stylesheet.cache);
  let cache = $[0];
  return new StyleSheet(cache, stylesheet.id, stylesheet.is_persistent);
}

/**
 * Create a cache, managing the styles. You can instanciate as much cache as
 * you want, if you need to manage different stylesheets.
 * Instanciating an `Ephemeral` _always_ succeed.
 */
export function stylesheet(strategy) {
  let id = unique_id();
  return new Ok(
    (() => {
      if (strategy instanceof Ephemeral) {
        return new StyleSheet($cache.new$(), id, false);
      } else {
        return new StyleSheet($cache.new$(), id, true);
      }
    })(),
  );
}

/**
 * Delete a persistent stylesheet. That function should be called for Persistent
 * Erlang stylesheet, and won't have any effect otherwise.
 */
export function dispose(_) {
  return undefined;
}
